import { HANDLE_MAINTENANCE_MODE } from "./constants";

export const handleMaintenance = (isMaintenance = false) => ({
  type: HANDLE_MAINTENANCE_MODE,
  isMaintenance
});
